import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param organisation OrganisationModel
 *
 * @return {Promise<any>|Promise}
 */
export default (function (organisation) {
    var url = applyPathVariables(EndPoints.SERVICE_ENTRIES_OPEN, { organisationId: organisation.id });
    var request = new Request({ method: Methods.GET, url: url, withCredentials: true, blockUI: false });
    return request.execute();
});
